import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import apiHelperService from '@/services'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import lookups from '@/assets/json/clientLookups.json'

const fetchInfo = async () => {
  return await apiHelperService.get(`/api/individual/info`)
}
const initInfo = async () => {
  const formStore = useFormStore()
  let { serviceId: serviceTransactionId } = router.currentRoute.value.params
  const res = await fetchInfo()
  const {
    englishFullName,
    arabicFullName,
    identityNumber,
    passportNumber,
    familyBookNumber,
    arabicFatherName,
    arabicFirstName,
    arabicFourthName,
    arabicGrandName,
    englishFatherName,
    englishFirstName,
    englishFourthName,
    englishGrandName,
    faithId,
    professionId,
    religionId,
    fileSequence,
    familyBookCityCode
  } = res

  formStore.form.setValues({
    applicantEngFullName: englishFullName,
    applicantArbFullName: arabicFullName,
    identityNumber: identityNumber,
    localPassportNumber: passportNumber,
    applicantArbFatherName: arabicFatherName,
    applicantArbFirstName: arabicFirstName,
    applicantArbFourthName: arabicFourthName,
    applicantArbThirdName: arabicGrandName,
    applicantEngFatherName: englishFatherName,
    applicantEngFirstName: englishFirstName,
    applicantEngFourthName: englishFourthName,
    applicantEngThirdName: englishGrandName,
    applicantFaithId: faithId,
    applicantProfessionId: professionId,
    applicantReligionId: religionId,
    arabicName: arabicFullName,
    familyMemArbFatherName: arabicFatherName,

    fileSeqNo: fileSequence,
    familyBookCityCode
  })

  const { femaleChildrenNaturalizationRequest } = lookups.ServiceTransactions
  if (serviceTransactionId == femaleChildrenNaturalizationRequest) {
    formStore.form.setValues({
      familyNumber: familyBookNumber
    })
  }
}

export default async function () {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const authStore = useAuthStore()

  let { administrativeRegionId, femaleChildrenRequestNumber } = router.currentRoute.value.query

  administrativeRegionId = authStore.isUserEstablishment
    ? authStore.user.administrativeRegionId
    : administrativeRegionId

  if (!femaleChildrenRequestNumber) {
    await initInfo()
  }

  try {
    formStore.extraMap = {
      localAddressUserActionEnum: null,
      administrativeRegionId,

      hideOldEmiratesIdCardCopyOptions:
        globalStore.startedService.hideOldEmiratesIdCardCopyOptionsForUnifiedForm,

      enableMobileAppAuthorizationNewRequest:
        globalStore.startedService.enableMobileAppAuthorizationNewRequest
    }
  } catch (error) {
    console.error('use719Preload', error)
  }
}
